import React from "react";
import { Link } from "react-router-dom";
import topHeaderLogo from "../assets/images/top-header-logo.png";
import sapiaLogo from "../assets/images/sapia-logo.png";
import { useRedirectUrl } from "../hooks/useRedirectUrl";
import styles from "./Header.module.scss";

interface Props {
  title?: string;
  redirectDefaultUrl?: string
}

export const Header: React.FC<Props> = ({
  title = "FirstInterview by Sapia",
  redirectDefaultUrl = "/"
}) => {
  const redirect = useRedirectUrl(redirectDefaultUrl);

  return (
    <div className={styles["header"]}>
      <Link to="/" style={{ textShadow: `none`, backgroundImage: `none` }}>
        <img src={sapiaLogo} alt="" style={{ width: 160 }} />
      </Link>
      <h2 className={styles["title"]}>{title}</h2>
      <div className={styles["headerMenu"]}>
        <ul>
          <li>
            <a href={redirect}>&lt; Back</a>
          </li>
          {/* <li>
            <a className="back-article" style={{cursor: 'pointer'}}>Support</a>
          </li> */}
        </ul>
      </div>
    </div>
  );
};
